import { faChartLine, faTachometer, faTasks } from '@fortawesome/pro-light-svg-icons'

import { generateUrls } from '@hooks/useTaskList'

import type { TaskListModel } from '@models/types'

export const generateTabBarItems = (taskList: Partial<TaskListModel>) => {
  const urls = generateUrls(taskList)
  const { editTaskListUrl, editTaskListTasksUrl, taskListAnalyticsUrl } = urls

  return [
    {
      href: editTaskListUrl,
      icon: faTachometer,
      key: 'overview',
      title: 'Overview',
    },
    {
      href: editTaskListTasksUrl,
      icon: faTasks,
      key: 'tasks',
      title: 'Tasks',
    },
    {
      href: taskListAnalyticsUrl,
      icon: faChartLine,
      key: 'analytics',
      title: 'Analytics',
    },
  ]
}

export default generateTabBarItems
